define(function(require) {
    // GEO09E06_REG_ADM_GEN layer definition config
    return {
        LAYER_ID : "GEO09E06_REG_ADM_GEN",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "CARTOVISTA",
        USE_TYPED_ARRAY : true,
        INDEX : 1,
        FIELDS : [
            {ID : "CD_REG_ADM", NAME : "Code", DATA_TYPE : "STRING"},
            {ID : "NOM_REG_ADM", NAME : "Nom", DATA_TYPE : "STRING"}
        ],
        STYLES : [
            {
                ID : "Région administrative",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_STYLE : "NONE",
                        STROKE_COLOR : "rgba(0,0,0,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : 4
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 9,
                    VISIBLE : true
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Région administrative",
            FEATURE_ID_DATACOLUMN : "CD_REG_ADM",
            FEATURE_NAME_DATACOLUMN : "NOM_REG_ADM",
            DATATIP_DATACOLUMNS : ["CD_REG_ADM", "NOM_REG_ADM"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["NOM_REG_ADM", "CD_REG_ADM"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["NOM_REG_ADM", "CD_REG_ADM"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            SEARCHABLE_DATACOLUMNS : ["CD_REG_ADM", "NOM_REG_ADM"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "NOM_REG_ADM",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false
        },
        ZOOM_LAYERING : {
            BASE_LAYER_ID : "GEO09E06_REG_ADM",
            QUERY_EXPRESSION : {
                LOGICAL_OPERATOR : null,
                QUERIES : [{FIELD : "CD_REG_ADM", OPERATOR : "=", VALUE : undefined}]
            },
            SWITCH_SCALE : 100000
        }
    };
});
